/**
 * This file is generated by `pnpm codegen` from the OpenAPI spec, DO NOT EDIT.
 */

import { makeData } from 'core/types/makeData'

import * as SchemaTypes from '../schema/types'

import * as MerchantTypes from './types'

export type MerchantsListKey = ['companies', string | undefined, 'merchants', unknown]

export type MerchantsListResponse = MerchantTypes.ResponseMerchantPagingResponse

export type MerchantsListVariables = {
  companyId: string | undefined
  body?: void
  query?: {
    parentMerchantId?: SchemaTypes.AnyId
  }
}

export const merchantsList = makeData<MerchantsListResponse, MerchantsListKey, MerchantsListVariables>({
  method: 'get',
  name: 'merchantsList',
  summary: 'Get merchants',
  path: '/companies/{companyId}/merchants',
  queryKey: ({ query, companyId }) => ['companies', companyId, 'merchants', query],
})

export type MerchantCreateKey = ['companies', string | undefined, 'merchants', unknown]

export type MerchantCreateResponse = MerchantTypes.ResponseMerchantResponse

export type MerchantCreateVariables = {
  companyId: string | undefined
  body?: MerchantTypes.RequestBodyMerchantPost
  query?: void
}

export const merchantCreate = makeData<MerchantCreateResponse, MerchantCreateKey, MerchantCreateVariables>({
  method: 'post',
  name: 'merchantCreate',
  summary: 'Create merchant',
  path: '/companies/{companyId}/merchants',
  queryKey: ({ query, companyId }) => ['companies', companyId, 'merchants', query],
})

export type MerchantGetKey = ['companies', string | undefined, 'merchants', string | undefined, unknown]

export type MerchantGetResponse = MerchantTypes.ResponseMerchantResponse

export type MerchantGetVariables = {
  companyId: string | undefined
  merchantId: string | undefined
  body?: void
  query?: void
}

export const merchantGet = makeData<MerchantGetResponse, MerchantGetKey, MerchantGetVariables>({
  method: 'get',
  name: 'merchantGet',
  summary: 'Get merchant by ID',
  path: '/companies/{companyId}/merchants/{merchantId}',
  queryKey: ({ query, companyId, merchantId }) => ['companies', companyId, 'merchants', merchantId, query],
})

export type MerchantUpdateKey = ['companies', string | undefined, 'merchants', string | undefined, unknown]

export type MerchantUpdateResponse = MerchantTypes.ResponseMerchantResponse

export type MerchantUpdateVariables = {
  companyId: string | undefined
  merchantId: string | undefined
  body?: MerchantTypes.RequestBodyMerchantPut
  query?: void
}

export const merchantUpdate = makeData<MerchantUpdateResponse, MerchantUpdateKey, MerchantUpdateVariables>({
  method: 'put',
  name: 'merchantUpdate',
  summary: 'Update merchant',
  path: '/companies/{companyId}/merchants/{merchantId}',
  queryKey: ({ query, companyId, merchantId }) => ['companies', companyId, 'merchants', merchantId, query],
})
